// extracted by mini-css-extract-plugin
export default {"container":"Kk-z","bubbleNav":"Lk-z","graphic":"Mk-z","contact":"Nk-z"};